export default __webpack_public_path__ + "static/media/title_en_pc.9b5dedf5.png";